import React from 'react';

/**
 * TimeColumn 組件 - 顯示時間欄（固定在左側）
 *
 * @param hours - 小時陣列（例如 [0, 1, 2, ..., 23]）
 * @param hourHeight - 每小時的高度（px）
 * @param timeColumnWidth - 時間欄寬度（px）
 */
interface TimeColumnProps {
  hours: number[];
  hourHeight: number;
  timeColumnWidth: number;
}

const TimeColumn: React.FC<TimeColumnProps> = ({
  hours,
  hourHeight,
  timeColumnWidth
}) => {
  return (
    <div
      style={{ width: `${timeColumnWidth}px`, minWidth: `${timeColumnWidth}px` }}
      className="flex-shrink-0"
    >
      {hours.map(hour => (
        <div
          key={hour}
          style={{ height: `${hourHeight}px` }}
          className="text-center text-sm text-gray-500 border-r border-b border-gray-200 py-1"
        >
          {hour}:00
        </div>
      ))}
    </div>
  );
};

export default TimeColumn;
